import Toast from './Toast';

/**
 * ToastStack — renders all queued toasts
 * Internal component used by ToastContext
 */
function ToastStack({ queue, onDismiss }) {
  if (!queue.length) return null;

  return (
    <div className="toast-stack" aria-live="polite" aria-atomic="false">
      {queue.map((t) => (
        <Toast key={t.id} {...t} onClose={() => onDismiss(t.id)} />
      ))}
    </div>
  );
}

export default ToastStack;
